<template>
  <div>
    <div class="header-sticky">
      <resend-bar />
      <Header />
    </div>
    <router-view />
    <Footer v-if="!$route.path.includes('profile') && !$route.path.includes('activity') && !$route.path.includes('support')" />
  </div>
</template>

<script>
import Header from "./Header.vue";
// import Header from "./HeaderGeneric.vue";
import Footer from "./Footer";
import ResendBar from "./resendBar.vue";

export default {
  name: "AppLayout",
  components: {
    Header,
    Footer,
    ResendBar
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/App/AppLayout.vue